module.exports = __webpack_public_path__ + "img/resmed-white.04266204.png";